import { Link } from 'react-router-dom';

import { embryoStageColor, embryoStageLabel, storageLabel, stageName, isFrozen } from '../../../core/constants/transfers';
import { PRESERVATION_METHODS } from '../../../core/constants/clivage';
import { embryoSourceLabel, EMBRYO_STATUS_LABEL } from '../../../core/constants/embryo';
import { useEmbryo } from '../contexts/embryos';

import '../../../common/styles/catalog.css';
import './styles/bank.css';

const METHOD_LABEL = Object.fromEntries(PRESERVATION_METHODS.map((m) => [m.value, m.label]));
const SEX_LABEL = { female: 'Hembra', male: 'Macho' };

function Field({ label, children }) {
    return (
        <div className="cat-detail__field">
            <span className="cat-detail__field-label">{label}</span>
            <span className="cat-detail__field-value">{children || <span className="cat-detail__empty">—</span>}</span>
        </div>
    );
}

// Detalle de un embrión ensamblado (admin-embryos.md GET /:id): atributos + linaje
// efectivo (donante/padre, y la OPU de origen si es de clivage). Sin edición: la
// edición operativa (sexar/congelar/grado) es tier posterior del contrato.
export default function EmbryoDetail({ embryoId }) {
    const { data: e, isLoading, error } = useEmbryo(embryoId);

    if (isLoading) return <div className="cat-detail__state">Cargando embrión…</div>;
    if (error || !e) return <div className="cat-detail__state">Embrión no encontrado.</div>;

    const l = e.lineage || {};
    const donor = l.donor;
    const sire = l.sire;
    const method = e.preservation?.method ? (METHOD_LABEL[e.preservation.method] || e.preservation.method) : null;

    return (
        <div className="cat-detail">
            <header className="cat-detail__header">
                <div>
                    <Link to="/admin/embryos" className="cat-detail__back">Banco de embriones</Link>
                    <div className="cat-detail__title-row">
                        <h1 className="cat-detail__title">{e.code || `#${e.id}`}</h1>
                        {e.stage && <span className="emb-chip emb-chip--stage" style={{ '--stage': embryoStageColor(e.stage) }}>{embryoStageLabel(e.stage)}</span>}
                        {isFrozen(e.storage) && <span className="emb-chip emb-chip--frozen">{storageLabel(e.storage)}</span>}
                    </div>
                </div>
            </header>

            <div className="cat-detail__card">
                <h2 className="cat-detail__section-title">Embrión</h2>
                <div className="cat-detail__grid">
                    <Field label="Origen">{embryoSourceLabel(e.source)}</Field>
                    <Field label="Estadio">{e.stage ? stageName(e.stage) : null}</Field>
                    <Field label="Preservación">{storageLabel(e.storage)}{method ? ` · ${method}` : ''}</Field>
                    <Field label="Sexado">{SEX_LABEL[e.sex]}</Field>
                    <Field label="Grado / calidad">{e.quality}</Field>
                    <Field label="Disponibilidad">{e.transferred ? 'Transferido' : 'Disponible'}</Field>
                    <Field label="Estado">{EMBRYO_STATUS_LABEL[e.status]}</Field>
                </div>
            </div>

            <div className="cat-detail__card">
                <h2 className="cat-detail__section-title">Genealogía</h2>
                <div className="cat-detail__grid">
                    <Field label="Donadora (madre)">{donor ? `${donor.name || '—'}${donor.number ? ` · ${donor.number}` : ''}` : null}</Field>
                    <Field label="Toro (padre)">{sire ? `${sire.name || '—'}${sire.register ? ` · ${sire.register}` : ''}` : null}</Field>
                    <Field label="Raza del toro">{sire?.race?.name}</Field>
                    {l.opu && <Field label="OPU de origen">{l.opu.code}</Field>}
                </div>
            </div>
        </div>
    );
}
